// Text preserved byte-for-byte from the legacy keys it replaces (schemeVerifyFarmer / VERIFY_FARMER / FARMER_PASSBOOK).
export const en = {
  "FARMER_VERIFY.HEADER_DEFAULT": "Verify your account",
  "FARMER_VERIFY.HEADER_FARMER_PASSBOOK": "Farmer Passbook",
  "FARMER_VERIFY.HEADER_SOIL_CARD": "Verify Farmer Details",
  "FARMER_VERIFY.ERROR_DBT_USER": "This mobile number belongs to a DBT registered farmer.",
  "FARMER_CONTEXT.UNAUTHORIZED_TITLE": "Access denied",
  "FARMER_CONTEXT.UNAUTHORIZED_NOTICE": "This page is only available to logged-in citizens or assisted-mode agents.",
  "FARMER_CONTEXT.PROFILE_ERROR": "We couldn't fetch your farmer details right now. Please try again in a moment.",
  "FARMER_CONTEXT.RETRY": "Retry",
  "DBT_HELPER.CANT_REMEMBER": "Can't remember your DBT ID?",
  "DBT_HELPER.RECOVER": "Recover",
  "DBT_HELPER.DONT_HAVE": "Don't have a DBT ID?",
  "DBT_HELPER.REGISTER_NOW": "Register Now",
  "IDENTITY_PICKER.TITLE": "Select an Account",
  "IDENTITY_PICKER.SUBTITLE": "To process further, select an account to proceed",
  "IDENTITY_PICKER.SELF": "Self",
  "IDENTITY_PICKER.FARMER": "Farmer",
  "IDENTITY_PICKER.PROCEED": "Proceed",
};

export const hi = {
  "FARMER_VERIFY.HEADER_DEFAULT": "अपना खाता सत्यापित करें",
  "FARMER_VERIFY.HEADER_FARMER_PASSBOOK": "किसान पासबुक",
  "FARMER_VERIFY.HEADER_SOIL_CARD": "किसान विवरण सत्यापित करें",
  // inferred, needs translator
  "FARMER_VERIFY.ERROR_DBT_USER": "यह मोबाइल नंबर एक डीबीटी पंजीकृत किसान का है।",
  "FARMER_CONTEXT.UNAUTHORIZED_TITLE": "पहुँच अस्वीकृत",
  "FARMER_CONTEXT.UNAUTHORIZED_NOTICE": "यह पृष्ठ केवल लॉग-इन किए हुए नागरिकों या सहायता-मोड एजेंटों के लिए उपलब्ध है।",
  "FARMER_CONTEXT.PROFILE_ERROR": "हम अभी आपका किसान विवरण नहीं ला सके। कृपया थोड़ी देर में पुनः प्रयास करें।",
  "FARMER_CONTEXT.RETRY": "पुनः प्रयास करें",
  "DBT_HELPER.CANT_REMEMBER": "क्या आपको अपनी डीबीटी आईडी याद नहीं है?",
  "DBT_HELPER.RECOVER": "पुनः प्राप्त करें",
  "DBT_HELPER.DONT_HAVE": "आपके पास डीबीटी आईडी नहीं है?",
  "DBT_HELPER.REGISTER_NOW": "अभी पंजीकरण करें",
  // inferred, needs translator
  "IDENTITY_PICKER.TITLE": "खाता चुनें",
  "IDENTITY_PICKER.SUBTITLE": "आगे बढ़ने के लिए, एक खाता चुनें",
  "IDENTITY_PICKER.SELF": "स्वयं",
  "IDENTITY_PICKER.FARMER": "किसान",
  "IDENTITY_PICKER.PROCEED": "आगे बढ़ें",
};
